import { ProgramService } from "@adfenix/types";
import styled from "styled-components";
import { useCustomTemplateContext } from "../util/CampaignTemplateContext";
import { useFormContext } from "react-hook-form";
import { Box } from "@adfenix/alexandria";
import { getChannelIcon } from "utils/channelIcons";
import { IconButton } from "components/IconButton/IconButton";
import { SRegularCircleX } from "@adfenix/icons";

interface Props {
  channel: ProgramService.ChannelType;
  selectedChannel: ProgramService.ChannelType;
}

const IconWrapper = styled(Box)<{
  isSelected: boolean;
}>`
  ${props =>
    props.isSelected
      ? "border: 1px solid #049BF2;"
      : "border: 1px solid transparent;"}

  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SelectableChannel = ({ channel, selectedChannel }: Props) => {
  const { setValue } = useFormContext<ProgramService.ProgramModel>();
  const { campaignKey } = useCustomTemplateContext();
  const isSelected = selectedChannel === channel;
  return (
    <IconWrapper isSelected={isSelected}>
      <IconButton
        testId={isSelected ? `selected-channel-${channel}` : undefined}
        label={`select-channel-${channel}`}
        onClick={() => {
          setValue(`${campaignKey}.channel`, channel);
        }}
      >
        {channel === "Unknown" ? <SRegularCircleX /> : getChannelIcon(channel)}
      </IconButton>
    </IconWrapper>
  );
};
